/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Erase_Old_PeriodsInputs */



/**
* | output |
* | --- |
* | "Overwrite old periods" |
*
* @param {Erase_Old_PeriodsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const erase_old_periods = /** @type {((inputs?: Erase_Old_PeriodsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Erase_Old_PeriodsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Overwrite old periods")
	return /** @type {LocalizedString} */ ("Écraser les anciennes périodes")
});